// store
import { useSelector } from 'store';

// context
import { useTenant } from 'context/TenantContext';
import { Feature } from 'context/tenantTypes';

// components
import WelcomeActionsPage from '@karehero/llama/components/pages/WelcomeActions/WelcomeActions';
import { ROUTES } from 'router/routes';

/**
 * WelcomeActions is the dashboard page.
 */
export const WelcomeActions = () => {
  // hooks
  const account = useSelector((state) => state.iam.account);
  const { tenant } = useTenant();

  // memos
  const isAdmin = account?.accountRole.name === 'KareHero Administrator';
  const isBacktesting = tenant.features.includes(Feature.BACKTESTING);

  return (
    <WelcomeActionsPage
      firstName={account?.firstName || 'User'}
      toManageCareCircles={'/admin/care-circle/manage'}
      toManageAccounts={isAdmin ? '/admin/account/manage' : undefined}
      toManageOrganizations={isAdmin ? '/admin/organization/manage' : undefined}
      toManageReferringPartners={
        isAdmin ? ROUTES.ADMIN_REFERRING_PARTNER_MANAGE : undefined
      }
      toManageActionPlan={isAdmin ? '/admin/action-plan' : undefined}
      toManageInvitedMembers={isAdmin ? '/admin/invite/manage' : undefined}
      toManagePartnerProducts={
        isAdmin ? ROUTES.ADMIN_PARTNER_PRODUCT_MANAGE : undefined
      }
      toCaseload={isAdmin ? ROUTES.ADMIN_CASELOAD : undefined}
      toBacktests={
        isAdmin && isBacktesting ? ROUTES.ADMIN_BACKTESTS : undefined
      }
    />
  );
};

export default WelcomeActions;
